import { NavLink } from 'react-router-dom';

const menuItems = [
  { to: '/dashboard', label: 'Tổng quan', icon: '📊' },
  { to: '/levels', label: 'Cấp độ', icon: '🎯' },
  { to: '/exams', label: 'Đề thi', icon: '📝' },
  { to: '/vocabulary', label: 'Từ vựng', icon: '📖' },
  { to: '/flashcards', label: 'Flashcard', icon: '🃏' },
  { to: '/leaderboard', label: 'Bảng xếp hạng', icon: '🏆' },
];

export default function Sidebar() {
  return (
    <aside className="fixed left-0 top-16 bottom-0 w-64 bg-white border-r border-gray-200 hidden lg:block overflow-y-auto">
      <nav className="p-4 space-y-1">
        {menuItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-primary-50 text-primary-700 font-medium'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
          >
            <span className="text-xl">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Bottom section */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200 bg-white">
        <div className="card bg-gradient-to-r from-primary-50 to-blue-50 border-primary-100">
          <div className="flex items-center gap-3">
            <span className="text-2xl">🎯</span>
            <div>
              <p className="text-sm font-medium text-gray-900">Nâng cấp Premium</p>
              <p className="text-xs text-gray-500">Không giới hạn luyện thi</p>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
